import { render, staticRenderFns } from "./SelectIcon.vue?vue&type=template&id=1f8f2437"
import script from "./SelectIcon.vue?vue&type=script&lang=js"
export * from "./SelectIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f8f2437')) {
      api.createRecord('1f8f2437', component.options)
    } else {
      api.reload('1f8f2437', component.options)
    }
    module.hot.accept("./SelectIcon.vue?vue&type=template&id=1f8f2437", function () {
      api.rerender('1f8f2437', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/Icon/SelectIcon.vue"
export default component.exports